import React from "react";
import * as Icons from "Components/Icons";
import { HashLinkCustom, RouteLink, PlainLink } from "./components";
import { NavLinkProps } from "./NavLink.types";

const NavLink: React.FC<NavLinkProps> = ({ children, counter, dropdown, badge, ...navLinkProps }) => {
   const inner = (<>
      {navLinkProps.icon ? React.createElement(navLinkProps.icon, { className: "portal-nav-link-icon" }) : null}
      <span className='portal-nav-link-text'>{children}</span>
      {
         counter
            ? <span className='portal-nav-link-counter'>{counter}</span>
            : null
      }
      {
         badge
            ? <span className="portal-nav-link-badge">{badge}</span>
            : null
      }
      {
         dropdown
            ? <Icons.Dropdown className='portal-nav-link-dropdown' />
            : null
      }
   </>);
   return (
      navLinkProps.linkType == "route"
         ? <RouteLink {...navLinkProps}>{inner}</RouteLink>
         : navLinkProps.linkType == "hash"
            ? <HashLinkCustom {...navLinkProps}>{inner}</HashLinkCustom>
            : <PlainLink {...navLinkProps}>{inner}</PlainLink>
   )
}

export default NavLink;